export default __webpack_public_path__ + "img/img_about_logo.fd1f4466.svg";